import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/borrar.png'


const _withScopeId = n => (_pushScopeId("data-v-1d3d2708"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tag" }
const _hoisted_2 = {
  href: "",
  target: "_blank"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", _hoisted_2, [
      _createElementVNode("p", null, _toDisplayString(_ctx.link.name), 1)
    ]),
    _createElementVNode("div", {
      class: "btn",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleDelete && _ctx.handleDelete(...args)))
    }, _hoisted_4)
  ]))
}